import styled from '@emotion/styled';
import React, { useRef } from 'react';
import { ModalRef } from '@/components/@IntranetLibrary/Modal';
import useModal from '@/hooks/useModal';
import OutlookModal from './OutlookModal';
import { useFormContext } from 'react-hook-form';
import { RecordFilter } from '@/types/api';
import useAi from '@/components/Record/hooks/useAi';
import { useTranslation } from 'react-i18next';
import OutlookIcon from '@/public/icons/record/outlook.svg';
import MobileBottomSheet, {
  MobileBottomSheetRef,
} from '@/components/@IntranetLibrary/MobileBottomSheet';
import usePlatform from '@/components/Record/hooks/usePlatform';
import OutlookContents from '@/components/Record/OutlookButton/OutlookModal/OutlookContents';

const OutlookButton = () => {
  const { t } = useTranslation();
  const outlookModal = useRef<ModalRef>(null);
  const { setValue, getValues } = useFormContext<RecordFilter>();
  const { isOwner } = useAi();

  const drawerRef = useRef<MobileBottomSheetRef>(null);
  const { isMobilePath } = usePlatform();

  const outlookSubject = getValues('meetingMsSubject');
  const meetingMsLink = getValues('meetingMsLink');
  const haveMsInfo = outlookSubject && meetingMsLink;

  const { openModal, closeModal } = useModal(outlookModal);
  const handleClick = () => {
    if (haveMsInfo && !isOwner) {
      window.open(meetingMsLink, '_blank', 'noopener,noreferrer');
    } else {
      isMobilePath ? drawerRef.current?.open() : openModal(); // 연결 안 돼 있으면 모달 열기
    }
  };

  return (
    <>
      {!isOwner && !haveMsInfo ? null : (
        <>
          <div style={{ display: 'flex', gap: '2px', alignItems: 'center' }}>
            <StyledButton onClick={handleClick} placeHolder={!haveMsInfo}>
              <div
                style={{
                  padding: '0 4px',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                <OutlookIcon />
              </div>
              <StyledButtonTitle>
                {haveMsInfo ? outlookSubject : t('Outlook 일정 불러오기')}
              </StyledButtonTitle>
              {outlookSubject && isOwner && (
                <StyledClear
                  onClick={(e) => {
                    setValue('meetingMsSubject', '');
                    setValue('meetingMsLink', '');
                    setValue('meetingMsId', '');
                    e.stopPropagation();
                  }}
                >
                  {t('연결 해제')}
                </StyledClear>
              )}
            </StyledButton>
          </div>
          {isMobilePath ? (
            <MobileBottomSheet
              ref={drawerRef}
              title={'Outlook 회의 선택'}
              notifyAppBar
            >
              <OutlookContents handleClose={() => drawerRef.current?.close()} />
            </MobileBottomSheet>
          ) : (
            <OutlookModal ref={outlookModal} handleClose={closeModal} />
          )}
        </>
      )}
    </>
  );
};

export default OutlookButton;

const StyledButton = styled.button<{ placeHolder: boolean }>`
  display: flex;
  align-items: center;
  gap: 2px;
  color: ${({ placeHolder }) => (placeHolder ? 'var(--dk-text, black)' : 'var(--dk-accent, #06c)')};
  font-size: 14px;
  line-height: 20px;
  border: 1px solid var(--dk-line, #e7e9ec);
  padding: 8px 4px;
  border-radius: 4px;
  &:hover {
    background-color: var(--dk-bg-subtle, #f9fafb);
  }
  &:active {
    background-color: var(--dk-bg-muted, #f3f5f6);
  }
`;
const StyledButtonTitle = styled.div`
  max-width: 300px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  box-sizing: content-box;
  padding: 0 4px 0 2px;
`;

const StyledClear = styled.button`
  color: var(--dk-text-secondary, #888d96);
  font-size: 12px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px; /* 150% */
  text-decoration-line: underline;
  text-decoration-style: solid;
  text-decoration-skip-ink: none;
  text-decoration-thickness: auto;
  text-underline-offset: auto;
  text-underline-position: from-font;
  white-space: nowrap;
`;
